module.exports = __webpack_public_path__ + "static/img/ydbg1@2x.eea7e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ydbg1@2x.png
// module id = rI6h
// module chunks = 1